import { useEffect } from 'react';
import { useSelector, useDispatch } from 'react-redux';

import { Store } from '@/shared/store';
import { getCollaterals, resetCollaterals } from '@/shared/store/borrows/actions';

type UserFetchCollateralsProps = {
    agreementAddress: string;
};

export const useFetchCollaterals = ({ agreementAddress }: UserFetchCollateralsProps) => {
    const dispatch = useDispatch();

    const { type, blockchainName, walletAddress, userCollaterals, loading } = useSelector(
        (state: Store) => ({
            blockchainName: state.wallets.network,
            walletAddress: state.wallets.active.address,
            type: state.wallets.active.type,
            userCollaterals: state.borrows.userCollaterals,
            loading: state.borrows.userBorrowsClosedLoading,
        }),
    );

    useEffect(() => {
        dispatch(resetCollaterals());
        dispatch(getCollaterals(agreementAddress));
    }, [type, blockchainName, walletAddress, agreementAddress]);

    return {
        data: userCollaterals,
        loading,
    };
};
